export default __webpack_public_path__ + "static/media/truck.59cbeb7d.svg";